import React from 'react'

import { cn } from '@/lib/utils'

export function MobileAppShell({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex min-h-0 flex-1 flex-col gap-[var(--mobile-page-gap,1.25rem)]',
        className,
      )}
      data-mobile-browse-shell
    >
      {children}
    </div>
  )
}
